module.exports = __webpack_public_path__ + "static/PMB_account_banner-e265c0927c6b724b105f1705c90e7385.png";